import React from 'react';
import { Coins } from 'lucide-react';
import { useCredits } from '@/hooks/useCredits';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const CreditBalance: React.FC = () => {
  const { credits, loading } = useCredits();

  if (loading || !credits) return null;

  const isLowCredits = credits.credits_remaining < 5;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link to="/credits">
            <Button
              variant={isLowCredits ? 'destructive' : 'outline'}
              size="sm"
              className="gap-2"
            >
              <Coins className="w-4 h-4" />
              <span className="font-semibold">{credits.credits_remaining}</span>
            </Button>
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {isLowCredits ? '⚠️ Low credits!' : 'Available credits'} - Click to purchase more
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
